import React from "react";
import { Link } from "react-router-dom";

export default function PageBradcrume({ Pagename, pagetitle1, pagetitle2 }) {
  return (
    <>
      {/* PageBradcrume Start  */}
      <section className="page-title">
        <div className="auto-container">
          <div className="title-outer">
            <h1>{Pagename}</h1>
            <ul className="page-breadcrumb">
              <li>
                <Link to="/" className="breadcrumb-box">
                  <i
                    className="fa fa-home breadcrumb-icon"
                    aria-hidden="true"
                  ></i>
                  <span className="breadcrumb-text">Home</span>
                </Link>
              </li>
              <li>{pagetitle1}</li>
              {pagetitle2 && <li>{pagetitle2}</li>}
            </ul>
          </div>
        </div>
      </section>
      {/* PageBradcrume  End */}
    </>
  );
}
